<template>
  <div class="projectInfoDetails">
    <h5>{{clickItem.title}}</h5>
    <span>更新时间:{{clickItem.time}}</span>
    <div class="imgBox">
      <el-image style="width: 100%"
        :src="clickItem.imgUrl"
        fit="contain"></el-image>
    </div>
    <p>{{clickItem.content}}</p>
  </div>
</template>

<script>
export default {
  props: {
    clickItem: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.projectInfoDetails {
  width: 95%;
  margin: 0 auto;
  .imgBox {
    width: 80%;
    margin: 0 auto;
  }
  h5 {
    text-align: center;
    font-size: 18px;
  }
  span {
    display: block;
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  p {
    margin: 20px 0;
    text-indent: 40px;
    line-height: 32px;
  }
}
</style>